/**
 * @generated SignedSource<<6a3f949a195ac1d22ff0c0a4c15599b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Units = "METRIC" | "US" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ClientBodyWeightCard_client$data = {
  readonly bodyWeight: ReadonlyArray<{
    readonly activityDate: string | null | undefined;
    readonly id: string;
    readonly value: {
      readonly measurement?: number;
    };
  }>;
  readonly units: Units;
  readonly " $fragmentType": "ClientBodyWeightCard_client";
};
export type ClientBodyWeightCard_client$key = {
  readonly " $data"?: ClientBodyWeightCard_client$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientBodyWeightCard_client">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClientBodyWeightCard_client",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "units",
      "storageKey": null
    },
    {
      "alias": "bodyWeight",
      "args": [
        {
          "kind": "Literal",
          "name": "measurementType",
          "value": "BODYWEIGHT"
        },
        {
          "kind": "Literal",
          "name": "metricType",
          "value": "CHECKIN_ANSWER_MEASUREMENT"
        }
      ],
      "concreteType": "ClientMetric",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "raw",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "activityDate",
          "storageKey": "activityDate(raw:true)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "measurement",
                  "storageKey": null
                }
              ],
              "type": "CheckinAnswerMeasurementValue",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "metrics(measurementType:\"BODYWEIGHT\",metricType:\"CHECKIN_ANSWER_MEASUREMENT\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2b00a80de5636eba17db9d0e72580ce2";

export default node;
